exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".load-trasaction-content {\n  margin-bottom: 0 !important;\n  padding: 10px 40px !important;\n}\n.load-trasaction-content .media .media-content {\n  text-align: center;\n}", ""]);

// exports
